import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const LorryHireChallansListPage = lazy(() => import("@/pages/lorry-hire-challans.index.page"));

export const Route = createFileRoute("/lorry-hire-challans/")({
  component: LorryHireChallansListPage,
});
